import React, { useCallback, useEffect, useState } from "react";
import { listReservations, cancelReservation } from "../api";
import { errMsg, fmtMoney, fmtDate, fmtDateTime, RES_STATUS } from "../utils";

const FILTERS = [
  { key: "", label: "Todos" },
  { key: "active", label: "Activos" },
  { key: "redeemed", label: "Redimidos" },
  { key: "expired", label: "Vencidos" },
  { key: "cancelled", label: "Cancelados" },
];

/** Mis cupones: lista con filtro de estado, ver voucher y cancelar activos. */
export default function Cupones({ onShowVoucher, onBalanceChange, onToast }) {
  const [filter, setFilter] = useState("");
  const [rows, setRows] = useState(null);
  const [error, setError] = useState("");
  const [cancelling, setCancelling] = useState("");

  const load = useCallback(async (status) => {
    setRows(null);
    setError("");
    try {
      const params = { limit: 100 };
      if (status) params.status = status;
      setRows(await listReservations(params));
    } catch (e) {
      setError(errMsg(e, "No se pudieron cargar tus cupones."));
      setRows([]);
    }
  }, []);

  useEffect(() => {
    load(filter);
  }, [filter, load]);

  async function cancel(r) {
    const ok = window.confirm(
      `¿Cancelar el cupón ${r.reservation_code}?\nEl valor apartado (${fmtMoney(r.committed_amount)}) volverá a tu cupo.`
    );
    if (!ok) return;
    setCancelling(r.reservation_code);
    try {
      await cancelReservation(r.reservation_code);
      onToast("Cupón cancelado.");
      onBalanceChange();
      load(filter);
    } catch (e) {
      onToast(errMsg(e, "No se pudo cancelar el cupón."));
    } finally {
      setCancelling("");
    }
  }

  return (
    <>
      <div className="section">Mis cupones</div>

      <div className="filters">
        {FILTERS.map((f) => (
          <button
            key={f.key}
            type="button"
            className={`filter ${filter === f.key ? "on" : ""}`}
            onClick={() => setFilter(f.key)}
          >
            {f.label}
          </button>
        ))}
      </div>

      {error && <div className="banner err">{error}</div>}

      {rows === null ? (
        <div className="center"><div className="spinner" /></div>
      ) : rows.length === 0 ? (
        !error && (
          <div className="card">
            <div className="empty">
              {filter ? "No tienes cupones en este estado." : "Aún no has creado cupones."}
            </div>
          </div>
        )
      ) : (
        rows.map((r) => {
          const st = RES_STATUS[r.status] || { label: r.status, cls: "" };
          return (
            <div className="card res-card" key={r.reservation_code || r.id}>
              <div className="res-head">
                <span className="res-code">{r.reservation_code}</span>
                <span className={`chip ${st.cls}`}>{st.label}</span>
              </div>
              <div className="res-route">{r.origin_name} → {r.destination_name}</div>
              <div className="res-meta">
                <span>Viaje: <b>{fmtDate(r.travel_date)}</b></span>
                <span>{r.passenger_count} pasajero{r.passenger_count > 1 ? "s" : ""}</span>
                <span><b>{fmtMoney(r.committed_amount)}</b></span>
              </div>
              {r.status === "redeemed" && r.redeemed_at && (
                <div className="res-extra">
                  Redimido el {fmtDateTime(r.redeemed_at)}
                  {r.payment_number ? ` · Pago ${r.payment_number}` : ""}
                </div>
              )}
              {r.status === "cancelled" && r.cancelled_at && (
                <div className="res-extra">Cancelado el {fmtDateTime(r.cancelled_at)}</div>
              )}
              {r.status === "active" && (
                <div className="res-extra">Vence: {fmtDateTime(r.valid_until)}</div>
              )}
              <div className="res-actions">
                <button type="button" className="btn-sm ghost" onClick={() => onShowVoucher(r)}>
                  Ver voucher
                </button>
                {r.status === "active" && (
                  <button
                    type="button"
                    className="btn-sm danger"
                    disabled={cancelling === r.reservation_code}
                    onClick={() => cancel(r)}
                  >
                    {cancelling === r.reservation_code ? "Cancelando…" : "Cancelar"}
                  </button>
                )}
              </div>
            </div>
          );
        })
      )}
    </>
  );
}
